var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { CountrySubmissionConfiguration } from "./CountrySubmissionConfiguration";
export class SubmissionConfiguration {
  constructor(_data) {
    /**
     */
    __publicField(this, "CompanyId");
    /**
     */
    __publicField(this, "CountryConfiguration");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof SubmissionConfiguration
     */
    __publicField(this, "$type", "V1.SubmissionConfiguration.SubmissionConfiguration");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.CompanyId = _data["CompanyId"];
      if (_data["CountryConfiguration"] && _data["CountryConfiguration"].constructor === Array) {
        this.CountryConfiguration = [];
        for (let item of _data["CountryConfiguration"]) {
          const countryConfiguration_ = new CountrySubmissionConfiguration();
          this.CountryConfiguration.push(countryConfiguration_.init(item));
        }
      }
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["CompanyId"] = this.CompanyId;
    if (this.CountryConfiguration && this.CountryConfiguration.constructor === Array) {
      _data["CountryConfiguration"] = [];
      for (let item of this.CountryConfiguration) {
        _data["CountryConfiguration"].push(item.toJSON());
      }
    }
    return _data;
  }
}
